import { createApi } from "@reduxjs/toolkit/query/react";
import { listAlertsRequest, listAlertsCountsResponse } from "../../types";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";

export const alertCountsApi = createApi({
  reducerPath: "alertCountsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["AlertCounts"],
  endpoints: (builder) => ({
    listAlertsCounts: builder.query<
      listAlertsCountsResponse,
      listAlertsRequest
    >({
      query: (params) => ({
        url: "/alerts/counts",
        method: "GET",
        params,
      }),
      providesTags: ["AlertCounts"],
      onQueryStarted: withErrorNotification("Failed to fetch alert counts"),
    }),
  }),
});

export const { useListAlertsCountsQuery } = alertCountsApi;
